import AdminEleven from "@/layouts/AdminEleven.vue";

export const settingsRoutes = [
  {
    path: "/configuracoes",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "configuracoes-omnichannel",
        path: "",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/configuracoes/GeneralSettings.vue"
          ),
        meta: {
          title: "Configuracoes",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "configuracao-omnichannel",
        path: "/omnichannel",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/configuracoes/General.vue"
          ),
        meta: {
          title: "Configuracoes/Omnichannel",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "configuracao-marketplace",
        path: "",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/configuracoes/MarketplaceSettings.vue"
          ),
        meta: {
          title: "Configuracoes/Marketplace",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
    ],
  },
];
